import ShowMoreButton from '../ShowMoreButton';
import AfterAjax from "../AfterAjax";
import SearchInput from "../SearchInput";
import SearchPlaceInput from "../SearchPlaceInput";
import ContactModal from '../ContactModal';
import Ga from '../Ga';
import Cookie from '../Cookie';

export default class ComponentLoader {
	constructor() {
		this.init();

		AfterAjax.addInitOnAjaxFunction(() => {
			this.init();
			this.initAfterAjax();
		});
	}

	init() {
		new ShowMoreButton();
		new SearchInput();
		new SearchPlaceInput();
		new ContactModal();
		new Cookie();

		// GA/GTM tracking only when the visitor has granted analytics consent (GDPR). The consent
		// instance is created by new Cookie() above; first-time consent (this pageview) is handled by
		// the Cookie onFirstAction/onChange callbacks, so this covers steady-state load + AJAX re-init.
		if (window.cookieConsent && window.cookieConsent.allowedCategory('analytics')) {
			(new Ga()).onPageView();
		}
	}

	initAfterAjax() {
		new ShowMoreButton();
	}
}
